<template>
    <div
        class="modal fade"
        :id="'dispachModal' + name"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-md modal-dialog-centered"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header bg-dark text-light">
                    <h5 class="modal-title" id="exampleModalLabel">
                        <template v-if="perc_import && perc_import == 100">
                            Execução realizada
                        </template>
                        <span v-else>
                            Aguardando execução...
                        </span>


                    </h5>

                    <button type="button" class="close text-light" data-dismiss="modal" aria-label="Close" v-if="perc_import && perc_import == 100">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row justify-content-center">
                        <div class="col col-1">
                            <span
                                class="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                                v-if="$store.state.loading"
                            ></span>
                            <span v-else-if="perc_import && perc_import == 100">
                                <i class="fa fa-check-circle text-success" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="col col-11">
                            <h4>{{ titulo }}</h4>
                        </div>
                    </div>

                    <template v-if="indeterminate">
                        <div class="progress mt-1 mb-1">
                            <div
                                class="indeterminate"
                                v-if="$store.state.loading"
                            ></div>
                            <div class="determinate" v-else></div>
                        </div>
                    </template>
                    <template v-if="perc_import !== null">
                        <div>{{ perc_import }}%</div>
                        <div class="progress" style="height: 20px;">
                            <div
                                class="progress-bar"
                                role="progressbar"
                                :style="'width: ' + perc_import + '%'"
                            ></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import { subscribe, unSubscribe } from "../../service/Notify.js";

export default {
    data() {
        return {
            dados: null,
            perc_import: null,
            indeterminate: true
        };
    },
    props: ["titulo", "name"],

    computed: { 
        nome_modal: function () { 
            return 'dispachModal' + this.name;
        }
    },

    methods: {
        executar: function(func, service, data, evento) {
            this.$store.commit("loading", true);

            $("#" + this.nome_modal).modal("show");

            subscribe(this.$store.state.dominio, evento, res => {
                this.$store.commit("loading", false);

                $("#" + this.nome_modal).modal("hide");

                this.$emit("refresh", res);
            });

            this.$util.atualizar(this, {
                service: service,
                func: func,
                redir_api: true, 
                continue_loading: true,
                dados: {
                    ...data
                },
                callback: () => {
                    this.$store.commit("loading", false);
                    $("#" + this.nome_modal).modal("hide");
                    this.$emit("refresh");
                },
                final: () => {
                    if (!this.$store.state.loading)
                        $("#" + this.nome_modal).modal("hide");
                }
            });
        },
        executar_axios: function(url, data, evento) {
            this.perc_import = null;
            this.indeterminate = true;
            this.$store.commit("loading", true);

            $("#" + this.nome_modal).modal("show");

            subscribe(this.$store.state.dominio, evento, (retorno) => {
                console.log('subscribe retorno 1', retorno);

                if (retorno && retorno.data && retorno.data.progresso) {
                    this.indeterminate = false;
                    this.perc_import = retorno.data.progresso;
                    return;
                }

                this.$store.commit("loading", false);

                $("#" + this.nome_modal).modal("hide");

                this.$emit("refreshAxios", retorno);

                unSubscribe(this.$store.state.dominio, evento);
            });

            this.axios
                .post(url, data)
                .then( () => {
                    // console.log(res);
                })
                .finally(() => {
                    // this.$store.commit("loading", false);
                });
        },
        executar_com_progresso: function(
            func,
            service,
            data,
            evento,
            evento_progress,
            fim_por_notific = false
        ) {
            this.$store.commit("loading", true);

            $("#" + this.nome_modal).modal("show");

            subscribe(this.$store.state.dominio, evento, res => {
                this.$store.commit("loading", false);

                $("#" + this.nome_modal).modal("hide");

                this.$emit("refresh", res);
            });

            if ( evento_progress ) {
             
                this.indeterminate = false;
                this.perc_import = 0;

                subscribe(this.$store.state.dominio, evento_progress, e => {
                    if (e && e.data && e.data.progresso) {
                        this.perc_import = e.data.progresso;
                    }
                });

            } else { 

                this.indeterminate = true;
                
            }

            this.$util.atualizar(this, {
                service: service,
                func: func,
                redir_api: true, 
                continue_loading: true,
                dados: {
                    ...data
                },
                callback: () => {
                    if ( !fim_por_notific ) { 
                        this.$store.commit("loading", false);
                        $("#" + this.nome_modal).modal("hide");
                        this.$emit("refresh");
                    }
                },
                final: () => {
                    if (!this.$store.state.loading)
                        $("#" + this.nome_modal).modal("hide");
                }
            });
        },
        executar_chunck: function(
            service,
            func,
            arr_data,
            arr_prop_name,
            extra_data,
            chunk_size
        ) {
            this.$store.commit("loading", true);

            this.indeterminate = false;

            let chunks = _.chunk(arr_data, chunk_size);
            let total = chunks.length;
            let proc = 0;
            this.perc_import = 0;

            $("#" + this.nome_modal).modal("show");
            this.processar_chunk(
                service,
                func,
                chunks,
                arr_prop_name,
                extra_data,
                total,
                proc
            );
        },

        processar_chunk: function(
            service,
            func,
            chunks,
            arr_prop_name,
            extra_data,
            total,
            proc
        ) {
            if (!chunks || !chunks.length) return;

            let lista = chunks[0];
            chunks = _.slice(chunks, 1);

            let dados = { ...extra_data };
            if (!arr_prop_name || arr_prop_name == "") {
                dados = { ...lista[0] };
            } else {
                dados[arr_prop_name] = lista;
            }

            this.$util.atualizar(this, {
                service: service,
                func: func,
                dados: dados,
                redir_api: true, 
                continue_loading: true,
                callback: res => {
                    proc++;
                    this.perc_import = Math.round((proc / total) * 100);

                    this.$emit("chunkRefresh", res);

                    if (chunks && chunks.length) {
                        this.processar_chunk(
                            service,
                            func,
                            chunks,
                            arr_prop_name,
                            extra_data,
                            total,
                            proc
                        );
                    } else {
                        this.perc_import = 100;

                        this.$store.commit("loading", false);
                        $("#" + this.nome_modal).modal("hide");
                        this.$emit("refresh");
                        this.$emit("chunkFinal");
                    }
                },
                final: () => {
                    if (!this.$store.state.loading)
                        $("#" + this.nome_modal).modal("hide");
                }
            });
        },

        show_modal: function() {
            $("#" + this.nome_modal).modal("show");
        },

        show_modal_fixo: function() {
            $("#" + this.nome_modal).modal({
                backdrop: "static",
                keyboard: false,
                show: true
            });
        },

        hide_modal: function() {
            $("#" + this.nome_modal).modal("hide");
        }
    }
};
</script>

<style></style>
